import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import { userData } from "utils/userData";
import GaugeChart from "react-gauge-chart";
import styled from "styled-components";
import { AiOutlineDown /* AiOutlineStar */ } from "react-icons/ai";
//eslint-disable-next-line
import { BsFillCalendarWeekFill } from "react-icons/bs";
import { VscCircleFilled } from "react-icons/vsc";
//import Analysis from "chartPages/Analysis";
import Institution from "chartPages/Institution";
import TransactionPerformance from "chartPages/TransactionPerformance";
import LineChartExample from "chartPages/LineChart";
import TodayTransactionsChart from "chartPages/TodayTransactionsChart";
import InstitutionDetails from "components/InstitutionDetails";
//import Analysis from "chartPages/Analysis";
import { ApiService } from "services";
import { toast } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import { FormInput } from "components";
import { /* kFormatter */ kFormatter2, kFormatter3 } from "utils/format";
import { handleCheckMetric } from "utils/handleMetricsChekc";
import Skeleton2 from "components/Skeleton2";
export default function Dashboard() {
  console.log(userData);
  //eslint-disable-next-line
  const color = "#200E32";
  //eslint-disable-next-line

  //eslint-disable-next-line
  const [viewAdmin, setViewAdmin] = useState(false);
  //eslint-disable-next-line
  const [viewInstitution, setViewInstitution] = useState(false);
  //eslint-disable-next-line

  const [dataDashboard, setDataDashboard] = useState();
  const savedData2 = JSON.parse(localStorage.getItem("savedData2"));

  const [oneBoundType, setOneBoundType] = useState(
    savedData2?.oneBoundType || "inbound"
  );

  const [dataDashboard4, setDataDashboard4] = useState();
  const [dataDashboard5, setDataDashboard5] = useState();
  const [dataDashboard6, setDataDashboard6] = useState();
  const [dataDashboard7, setDataDashboard7] = useState();
  const [dataDashboard8, setDataDashboard8] = useState();
  const [dataDashboard9, setDataDashboard9] = useState();
  const [dataDashboard10, setDataDashboard10] = useState();

  useEffect(() => {
    localStorage.setItem(
      "savedData2",
      JSON.stringify({
        dataDashboard: dataDashboard || savedData2?.dataDashboard,
        dataDashboard4: dataDashboard4 || savedData2?.dataDashboard4,
        dataDashboard5: dataDashboard5 || savedData2?.dataDashboard5,
        dataDashboard6: dataDashboard6 || savedData2?.dataDashboard6,
        dataDashboard7: dataDashboard7 || savedData2?.dataDashboard7,
        dataDashboard8: dataDashboard8 || savedData2?.dataDashboard8,
        dataDashboard9: dataDashboard9 || savedData2?.dataDashboard9,
        dataDashboard10: dataDashboard10 || savedData2?.dataDashboard10,
        oneBoundType: oneBoundType,
        seconds: seconds,
      })
    );
    //eslint-disable-next-line
  }, [
    dataDashboard,
    dataDashboard4,
    dataDashboard5,
    dataDashboard6,
    dataDashboard7,
    dataDashboard8,
    dataDashboard9,
    dataDashboard10,
  ]);

  //eslint-disable-next-line
  const [searchInput, setSearchInput] = useState("");
  const savedData = JSON.parse(localStorage.getItem("savedData"));

  const [seconds, setSeconds] = useState(Number(savedData2?.seconds || 300));
  const [secondsEnter, setSecondsEnter] = useState(
    Number(savedData?.seconds || 300)
  );
  const [secondsEnter2, setSecondsEnter2] = useState(
    Number(savedData?.seconds || 300)
  );
  const [secondsOpen, setSecondsOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);

  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);
  const [loading8, setLoading8] = useState(false);
  const [loading9, setLoading9] = useState(false);
  const [loading10, setLoading10] = useState(false);
  const [loading11, setLoading11] = useState(false);

  const [dashboardData, setDashboardData] = useState();
  const [dashboardData2, setDashboardData2] = useState();
  const [todayStats, setTodaysStats] = useState();
  const [transactionPerformance, setTransactionPerformance] = useState();
  const [transactionReport, setTransactionReport] = useState();
  const [institutionPerformance, setInstitutionPerformance] = useState();

  useEffect(() => {
    localStorage.setItem(
      "savedData",
      JSON.stringify({
        dashboardData: dashboardData || savedData?.dashboardData,
        dashboardData2: dashboardData2 || savedData?.dashboardData2,
        todayStats: todayStats || savedData?.todayStats,
        institutionPerformance:
          institutionPerformance || savedData?.institutionPerformance,
        transactionPerformance:
          transactionPerformance || savedData?.transactionPerformance,
        transactionReport: transactionReport || savedData?.transactionReport,
        seconds: secondsEnter2,
      })
    );

    //eslint-disable-next-line
  }, [
    dashboardData,
    dashboardData2,
    todayStats,
    institutionPerformance,
    transactionPerformance,
    transactionReport,
  ]);

  //eslint-disable-next-line
  const [dateFrom, setDateFrom] = useState();
  //eslint-disable-next-line
  const [dateTo, setDateTo] = useState();

  const [changedState, setChangedState] = useState(false);

  /* INSTITUTION DASH */
  const getInstitutionss = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      setLoading(true);

      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setLoading(false);
        setDataDashboard(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionss4 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      setLoading5(true);

      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setLoading5(false);
        setDataDashboard4(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading5(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionss5 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      setLoading6(true);

      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setLoading6(false);
        setDataDashboard5(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading6(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getInstitutionss6 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      setLoading7(true);

      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setLoading7(false);
        setDataDashboard6(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading7(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionss7 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      setLoading8(true);

      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setLoading8(false);
        setDataDashboard7(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading8(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionss8 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      setLoading9(true);

      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setLoading9(false);
        setDataDashboard8(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading9(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionss9 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      setLoading10(true);

      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setLoading10(false);
        setDataDashboard9(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading10(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionss10 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      setLoading11(true);

      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setLoading11(false);
        setDataDashboard10(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading11(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionssLoad = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setDataDashboard(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionssLoad4 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setDataDashboard4(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionssLoad5 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setDataDashboard5(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getInstitutionssLoad6 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setDataDashboard6(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionssLoad7 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setDataDashboard7(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionssLoad8 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setDataDashboard8(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionssLoad9 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setDataDashboard9(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getInstitutionssLoad10 = async (id) => {
    if (
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "bankUser1" ||
      userData?.userDetail?.role === "bankUser2" ||
      userData?.userDetail?.role === "nonBankAdmin" ||
      userData?.userDetail?.role === "nonBankUser1" ||
      userData?.userDetail?.role === "nonBankUser2"
    ) {
      try {
        const data = await ApiService.getInstitutionDashboard(id);
        setDataDashboard10(data);
        console.log(data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  useEffect(() => {
    if (savedData2) {
      return;
    } else {
      getInstitutionss(
        `/${userData?.userDetail?.institution?.id}?direction=inbound&reportType=indicator&indicatorLastPeriod=${secondsEnter}`
      );
      getInstitutionss4(
        `/${userData?.userDetail?.institution?.id}?direction=inbound&reportType=approvalRate&indicatorLastPeriod=${secondsEnter}`
      );
      getInstitutionss5(
        `/${userData?.userDetail?.institution?.id}?direction=inbound&reportType=adminUsers&indicatorLastPeriod=${secondsEnter}`
      );

      getInstitutionss6(
        `/${userData?.userDetail?.institution?.id}?direction=inbound&reportType=adminUsers&indicatorLastPeriod=${seconds}`
      );
      getInstitutionss7(
        `/${userData?.userDetail?.institution?.id}?direction=inbound&reportType=recentBanks&indicatorLastPeriod=${secondsEnter}`
      );
      getInstitutionss8(
        `/${userData?.userDetail?.institution?.id}?direction=inbound&reportType=adminUsers&indicatorLastPeriod=${secondsEnter}`
      );
      getInstitutionss9(
        `/${userData?.userDetail?.institution?.id}?direction=inbound&reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}`
      );
    }
    getInstitutionss10(
      `/${userData?.userDetail?.institution?.id}?direction=inbound&reportType=transaction&indicatorLastPeriod=${secondsEnter}`
    );
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getInstitutionssLoad(
        `/${userData?.userDetail?.institution?.id}?direction=${oneBoundType}&reportType=indicator&indicatorLastPeriod=${seconds}`
      );
      getInstitutionssLoad4(
        `/${userData?.userDetail?.institution?.id}?direction=${oneBoundType}&reportType=approvalRate&indicatorLastPeriod=${seconds}`
      );
      getInstitutionssLoad5(
        `/${userData?.userDetail?.institution?.id}?direction=${oneBoundType}&reportType=adminUsers&indicatorLastPeriod=${seconds}`
      );

      getInstitutionssLoad7(
        `/${userData?.userDetail?.institution?.id}?direction=${oneBoundType}&reportType=recentBanks&indicatorLastPeriod=${seconds}`
      );
      getInstitutionssLoad8(
        `/${userData?.userDetail?.institution?.id}?direction=${oneBoundType}&reportType=adminUsers&indicatorLastPeriod=${seconds}`
      );
      getInstitutionssLoad9(
        `/${userData?.userDetail?.institution?.id}?direction=${oneBoundType}&reportType=transactionPerformance&indicatorLastPeriod=${seconds}`
      );
      getInstitutionssLoad10(
        `/${userData?.userDetail?.institution?.id}?direction=${oneBoundType}&reportType=transaction&indicatorLastPeriod=${seconds}`
      );
    }, seconds * 1000);
    return () => clearInterval(interval);

    //eslint-disable-next-line
  }, [seconds, oneBoundType]);

  useEffect(() => {
    const interval = setInterval(() => {
      getInstitutionssLoad6(
        `/${userData?.userDetail?.institution?.id}?direction=${oneBoundType}&reportType=adminUsers&indicatorLastPeriod=${seconds}`
      );
    }, 15 * 1000);
    return () => clearInterval(interval);

    //eslint-disable-next-line
  }, [oneBoundType]);

  /* INSTITUTION DASH */

  /* MAIN DASH */

  const getDashboardAnalysis = async (param) => {
    setLoading(true);
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setLoading(false);
        setDashboardData(data?.data);
      } catch (err) {
        setLoading(false);
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getDashboardAnalysiss = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setDashboardData2(data?.data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getDashboardAnalysis2 = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      setLoading(true);
      setSecondsOpen(false);
      setDateFilter(false);

      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setDashboardData(data?.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
      setLoading(false);
    }
  };

  const getDashboardAnalysis3 = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      setLoading(true);
      setSecondsOpen(false);
      setDateFilter(false);

      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setDashboardData2(data?.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
      setLoading(false);
    }
  };

  const getTodayStats = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      setLoading3(true);
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setTodaysStats(data?.data);
        setLoading3(false);
        console.log(data?.data, "stats");
      } catch (err) {
        console.log(err);
        setLoading3(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getTransactionPerformance = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      setLoading2(true);
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setLoading2(false);
        setTransactionPerformance(data?.data);
      } catch (err) {
        console.log(err);
        setLoading2(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getTransactionReport = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      setLoading2(true);
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setLoading2(false);
        setTransactionReport(data?.data);
      } catch (err) {
        console.log(err);
        setLoading2(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getInstitutionPerformance = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      setLoading4(true);

      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setLoading4(false);
        setInstitutionPerformance(data?.data);
      } catch (err) {
        console.log(err);
        setLoading4(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getInstitutionPerformance2 = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setInstitutionPerformance(data?.data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getDashboardAnalysisLoad = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setDashboardData(data?.data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getDashboardAnalysissLoad = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setDashboardData2(data?.data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getTodayStatsLoad = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setTodaysStats(data?.data);
        console.log(data?.data, "stats");
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getTransactionPerformanceLoad = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setTransactionPerformance(data?.data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getTransactionReportLoad = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setTransactionReport(data?.data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const siteAnalytics =
    dashboardData?.[0] || savedData?.dashboardData?.[0] || {};
  const siteAnalytics2 =
    dashboardData2?.[0] || savedData?.dashboardData2?.[0] || {};
  const todayStatsData = todayStats?.[0] || savedData?.todayStats?.[0] || {};
  const transactionPerformanceData =
    transactionPerformance?.[0] || savedData?.transactionPerformance?.[0] || {};
  const transactionReportData =
    transactionReport?.[0] || savedData?.transactionReport?.[0] || {};
  const institutionPerformanceData =
    institutionPerformance?.[0] || savedData?.institutionPerformance?.[0] || {};

  const sitePerformanceIndicator =
    siteAnalytics?.sitePerformanceIndicator || [];
  const siteApprovalRate = siteAnalytics2?.siteApprovalRate || [];

  const recentTransactions = siteAnalytics?.recentTransactions;

  //eslint-disable-next-line
  const transactionReportInfo = transactionReportData?.transactionReport || [];
  //eslint-disable-next-line
  const transactionPerformanceInfo =
    transactionPerformanceData?.transactionPerformance || [];
  const todayStatsInfo = todayStatsData || [];
  const institutionPerformanceInfo =
    institutionPerformanceData?.institutionPerformance || [];

  const totalCount = todayStatsInfo?.totalTransactionCount || 0;
  const totalAmount = todayStatsInfo?.totalTransactionAmount || 0;
  const pendingTransactionCount = todayStatsInfo?.pendingTransactionCount || 0;
  const successTransactionCount = todayStatsInfo?.successTransactionCount || 0;
  const failedTransactionCount = todayStatsInfo?.failedTransactionCount || 0;

  const pendingTransactionAmount =
    todayStatsInfo?.pendingTransactionAmount || 0;
  const successTransactionAmount =
    todayStatsInfo?.successTransactionAmount || 0;
  const failedTransactionAmount = todayStatsInfo?.failedTransactionAmount || 0;

  console.log(
    //transactionPerformanceInfo
    transactionReportInfo
    //institutionPerformanceInfo
  );

  const [boundType, setBoundType] = useState("inboundTransaction");
  const [boundType2, setBoundType2] = useState("Inbound");
  const [ipDuration, setIpDuration] = useState("daily");
  const [institutionType, setInstitutionType] = useState("");

  //eslint-disable-next-line
  const [dateFilter, setDateFilter] = useState(false);

  useEffect(() => {
    if (savedData) {
      return;
    } else {
      getDashboardAnalysis(
        `?reportType=indicator&indicatorLastPeriod=${secondsEnter}`
      );
      getDashboardAnalysiss(
        `?reportType=approvalRate&indicatorLastPeriod=${secondsEnter}`
      );

      getTodayStats(
        `?reportType=todayStat&indicatorLastPeriod=${secondsEnter}`
      );
      getTransactionPerformance(
        `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}`
      );
      getTransactionReport(
        `?reportType=transactionReport&indicatorLastPeriod=${secondsEnter}`
      );
      getInstitutionPerformance(
        `?reportType=institutionPerformance&indicatorLastPeriod=${secondsEnter}`
      );
    }

    //eslint-disable-next-line
  }, []);

  function formatTime(seconds) {
    return [
      seconds / 60 / 60 / 24 >= 1
        ? `${parseInt(seconds / 60 / 60 / 24)}d `
        : "",
      seconds / 60 / 60 < 24
        ? seconds / 60 / 60 === 0
          ? ""
          : `${parseInt(seconds / 60 / 60)}h `
        : "",
      (seconds / 60) % 60 !== 0 ? `${parseInt((seconds / 60) % 60)}m ` : "",
      seconds % 60 !== 0 ? `${parseInt(seconds % 60)}s` : "",
    ]
      .join("")
      .replace(/\b(\d)\b/g, "0$1");
  }
  const ipDurate = ipDuration;
  useEffect(() => {
    const interval = setInterval(() => {
      if (userData?.userDetail?.role === "chiefAdmin") {
        getDashboardAnalysisLoad(
          `?reportType=indicator&indicatorLastPeriod=${secondsEnter}`
        );
        getDashboardAnalysissLoad(
          `?reportType=approvalRate&indicatorLastPeriod=${secondsEnter}`
        );

        getInstitutionPerformance2(
          `?reportType=institutionPerformance&ipDuration=${
            ipDuration === "weekly" ? "weekly" : "daily"
          }&indicatorLastPeriod=${secondsEnter}`
        );

        getTransactionPerformanceLoad(
          `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}`
        );
        getTransactionReportLoad(
          `?reportType=transactionReport&indicatorLastPeriod=${secondsEnter}`
        );
      } else {
        if (
          handleCheckMetric("sitePerformance", userData?.userDetail?.metrics)
        ) {
          getDashboardAnalysisLoad(
            `?reportType=indicator&indicatorLastPeriod=${secondsEnter}`
          );
          getDashboardAnalysissLoad(
            `?reportType=approvalRate&indicatorLastPeriod=${secondsEnter}`
          );
        }

        if (
          handleCheckMetric(
            "institutionPerformance",
            userData?.userDetail?.metrics
          )
        ) {
          getInstitutionPerformance2(
            `?reportType=institutionPerformance&ipDuration=${ipDurate}&indicatorLastPeriod=${secondsEnter}`
          );
        }
        if (
          handleCheckMetric("transactionReport", userData?.userDetail?.metrics)
        ) {
          getTransactionReportLoad(
            `?reportType=transactionReport&indicatorLastPeriod=${secondsEnter}`
          );
        }

        if (
          handleCheckMetric(
            "transactionPerformance",
            userData?.userDetail?.metrics
          )
        ) {
          getTransactionPerformanceLoad(
            `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}`
          );
        }
      }
    }, secondsEnter2 * 1000);
    return () => clearInterval(interval);

    //eslint-disable-next-line
  }, [secondsEnter2, ipDurate]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        userData?.userDetail?.role === "chiefAdmin" ||
        userData?.userDetail?.role === "subAdmin1" ||
        userData?.userDetail?.role === "subAdmin2"
      ) {
        if (
          handleCheckMetric("todayTransaction", userData?.userDetail?.metrics)
        ) {
          getTodayStatsLoad(
            `?reportType=todayStat&indicatorLastPeriod=${secondsEnter}`
          );
        }
      }
    }, 15 * 1000);
    return () => clearInterval(interval);

    //eslint-disable-next-line
  }, []);
  /*  var max = 0;
  var data = [
    20000, 40000, 80000, 160000, 320000, 640000, 1280000, 2560000, 5120000,
    10240000, 20480000, 40960000, 81920000,
  ]; */

  /* data.map((d) => {
    return (max = Math.max(max, d));
  }); */
  /* CHART CONFIGS */
  const options = {
    series: [
      {
        name: "Performance info",
        data:
          institutionPerformanceInfo
            ?.filter((item) => item[boundType] !== 0)
            ?.map((item) => item[boundType]) || [],
        color: "#8BC0FF",
      },
    ],
    options: {
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
        onDatasetHover: {
          highlightDataSeries: false,
        },
        x: {
          show: true,
        },
        y: {
          formatter: function (val) {
            return kFormatter3(val);
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
        z: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? `₦ ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
              ? `₦${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
              : Math.abs(val) > 999
              ? `₦${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
              : Math.sign(val) * Math.abs(val);
          },
          title: "Size: ",
        },
        marker: {
          show: true,
        },
        items: {
          display: "flex",
        },
        fixed: {
          enabled: false,
          position: "topRight",
          offsetX: 0,
          offsetY: 0,
        } /*  */,
      },
      label: institutionPerformanceInfo?.map((item) => item[boundType]) || [],
      chart: {
        type: "bar",
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          columnWidth: "70%",
          barHeight: "70%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        labels: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? `₦ ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
              ? `₦${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
              : Math.abs(val) > 999
              ? `₦${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
              : Math.sign(val) * Math.abs(val);
          },
        },
        categories:
          institutionPerformanceInfo
            ?.filter((item) => item[boundType] !== 0)
            ?.map((item) => item?.institution) || [],
      },

      yaxis: {
        labels: {
          show: true,
          style: {
            fontSize: "10px",
          },
        },
      },
    },
  };

  const options2 = {
    series: [
      {
        name: "Success",
        data: transactionPerformanceInfo?.map((item) => item?.success) || [],
        color: "#01A926",
      },
      {
        name: "Pending",
        data: transactionPerformanceInfo?.map((item) => item?.pending) || [],
        color: "#FF993A",
      },
      {
        name: "Failed",
        data: transactionPerformanceInfo?.map((item) => item?.failed) || [],
        color: "#FF2E00",
      },
    ],
    options: {
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
        onDatasetHover: {
          highlightDataSeries: false,
        },
        x: {
          show: true,
        },
        y: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? ` ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
              ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
              : Math.abs(val) > 999
              ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
              : Math.sign(val) * Math.abs(val);
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
        z: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? `${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
              ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
              : Math.abs(val) > 999
              ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
              : Math.sign(val) * Math.abs(val);
          },
          title: "Size: ",
        },
        marker: {
          show: true,
        },
        items: {
          display: "flex",
        },
        fixed: {
          enabled: false,
          position: "topRight",
          offsetX: 0,
          offsetY: 0,
        },
      },
      labels:
        transactionPerformanceInfo?.map((item) =>
          boundType2 === "Inbound"
            ? item?.successInbound
            : item?.successOutbound
        ) || [],

      chart: {
        type: "bar",
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 0,
          columnWidth: "36%",
          dataLabels: {
            total: {
              enabled: false,
              style: {
                fontSize: "0px",
                fontWeight: 10,
              },
            },
          },
        },
      },
      xaxis: {
        categories:
          transactionPerformanceInfo?.map((item) => item?.institution) || [],
        labels: {
          rotate: 0,

          style: {
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? ` ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
              ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
              : Math.abs(val) > 999
              ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
              : Math.sign(val) * Math.abs(val);
          },
        },
      },
      legend: {
        show: false,
      },
      fill: {
        opacity: 1,
      },
      dataLabels: {
        enabled: false,
      },
    },
  };

  const options3 = {
    series: [
      successTransactionCount,
      failedTransactionCount,
      pendingTransactionCount,
    ],
    options: {
      labels: [
        `<span>Successful <br/> ${kFormatter3(
          successTransactionAmount
        )} <br/> ${kFormatter2(successTransactionCount)}</span> `,
        `<span>Failed <br/> ${kFormatter3(
          failedTransactionAmount
        )}<br/> ${kFormatter2(failedTransactionCount)} </span>  `,
        `<span>Pending <br/> ${kFormatter3(
          pendingTransactionAmount
        )}<br/> ${kFormatter2(pendingTransactionCount)}</span> `,
      ],
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
        onDatasetHover: {
          highlightDataSeries: false,
        },
        x: {
          show: true,
        },
        y: {
          formatter: function (val) {
            return val - val === 0 ? "" : "";
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },

        marker: {
          show: true,
        },
        items: {
          display: "flex",
        },
        fixed: {
          enabled: false,
          position: "topRight",
          offsetX: 0,
          offsetY: 0,
        },
      },
      chart: {
        type: "donut",
      },
      colors: ["#01A926", "#FE0004", "#F9C74F"],

      dataLabels: {
        enabled: false,
      },

      legend: {
        position: "right",
        offsetY: 0,
        height: 150,
        show: false,
      },
    },
  };

  function followingDay1(date = new Date()) {
    date.setDate(date.getDate() + 1);

    return date;
  }

  const followingDay = followingDay1();

  return (
    <DashboardLayout>
      {userData?.userDetail?.role === "bankAdmin" && (
        <InstitutionDetails
          loading={loading2}
          loading4={loading5}
          loading5={loading6}
          loading6={loading7}
          loading7={loading8}
          loading8={loading9}
          loading9={loading10}
          loading10={loading11}
          callMain4={getInstitutionss4}
          callMain5={getInstitutionss5}
          callMain6={getInstitutionss6}
          callMain7={getInstitutionss7}
          callMain8={getInstitutionss8}
          callMain9={getInstitutionss9}
          callMain10={getInstitutionss10}
          data4={savedData2?.dataDashboard4 || dataDashboard4}
          data5={savedData2?.dataDashboard5 || dataDashboard5}
          data6={savedData2?.dataDashboard6 || dataDashboard6}
          data7={savedData2?.dataDashboard7 || dataDashboard7}
          data8={savedData2?.dataDashboard8 || dataDashboard8}
          data9={savedData2?.dataDashboard9 || dataDashboard9}
          data10={savedData2?.dataDashboard10 || dataDashboard10}
          changedState={changedState}
          setChangedState={setChangedState}
          data={savedData2?.dataDashboard || dataDashboard}
          boundType={savedData2?.oneBoundType || oneBoundType}
          setBoundType={setOneBoundType}
          seconds={seconds}
          setSeconds={setSeconds}
          callMain={getInstitutionss}
          id={userData?.userDetail?.institution?.id}
          callBound={() => {
            getInstitutionss(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=indicator`
            );

            getInstitutionss4(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=approvalRate`
            );

            getInstitutionss5(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss6(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );

            getInstitutionss7(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=recentBanks`
            );

            getInstitutionss8(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );

            getInstitutionss9(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transactionPerformance`
            );
            getInstitutionss10(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transaction`
            );
          }}
        />
      )}
      {userData?.userDetail?.role === "bankUser1" && (
        <InstitutionDetails
          loading={loading2}
          loading4={loading5}
          loading5={loading6}
          loading6={loading7}
          loading7={loading8}
          loading8={loading9}
          loading9={loading10}
          loading10={loading11}
          callMain4={getInstitutionss4}
          callMain5={getInstitutionss5}
          callMain6={getInstitutionss6}
          callMain7={getInstitutionss7}
          callMain8={getInstitutionss8}
          callMain9={getInstitutionss9}
          callMain10={getInstitutionss10}
          data4={savedData2?.dataDashboard4 || dataDashboard4}
          data5={savedData2?.dataDashboard5 || dataDashboard5}
          data6={savedData2?.dataDashboard6 || dataDashboard6}
          data7={savedData2?.dataDashboard7 || dataDashboard7}
          data8={savedData2?.dataDashboard8 || dataDashboard8}
          data9={savedData2?.dataDashboard9 || dataDashboard9}
          data10={savedData2?.dataDashboard10 || dataDashboard10}
          changedState={changedState}
          setChangedState={setChangedState}
          data={savedData2?.dataDashboard || dataDashboard}
          boundType={savedData2?.oneBoundType || oneBoundType}
          setBoundType={setOneBoundType}
          seconds={seconds}
          setSeconds={setSeconds}
          callMain={getInstitutionss}
          id={userData?.userDetail?.institution?.id}
          callBound={() => {
            getInstitutionss(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=indicator`
            );

            getInstitutionss4(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=approvalRate`
            );

            getInstitutionss5(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss6(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss7(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=recentBanks`
            );

            getInstitutionss8(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );

            getInstitutionss9(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transactionPerformance`
            );
            getInstitutionss10(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transaction`
            );
          }}
        />
      )}

      {userData?.userDetail?.role === "bankUser2" && (
        <InstitutionDetails
          loading={loading2}
          loading4={loading5}
          loading5={loading6}
          loading6={loading7}
          loading7={loading8}
          loading8={loading9}
          loading9={loading10}
          loading10={loading11}
          callMain4={getInstitutionss4}
          callMain5={getInstitutionss5}
          callMain6={getInstitutionss6}
          callMain7={getInstitutionss7}
          callMain8={getInstitutionss8}
          callMain9={getInstitutionss9}
          callMain10={getInstitutionss10}
          data4={savedData2?.dataDashboard4 || dataDashboard4}
          data5={savedData2?.dataDashboard5 || dataDashboard5}
          data6={savedData2?.dataDashboard6 || dataDashboard6}
          data7={savedData2?.dataDashboard7 || dataDashboard7}
          data8={savedData2?.dataDashboard8 || dataDashboard8}
          data9={savedData2?.dataDashboard9 || dataDashboard9}
          data10={savedData2?.dataDashboard10 || dataDashboard10}
          changedState={changedState}
          setChangedState={setChangedState}
          data={savedData2?.dataDashboard || dataDashboard}
          boundType={savedData2?.oneBoundType || oneBoundType}
          setBoundType={setOneBoundType}
          seconds={seconds}
          setSeconds={setSeconds}
          callMain={getInstitutionss}
          id={userData?.userDetail?.institution?.id}
          callBound={() => {
            getInstitutionss(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=indicator`
            );

            getInstitutionss4(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=approvalRate`
            );

            getInstitutionss5(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss6(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss7(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=recentBanks`
            );

            getInstitutionss8(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );

            getInstitutionss9(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transactionPerformance`
            );
            getInstitutionss10(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transaction`
            );
          }}
        />
      )}

      {userData?.userDetail?.role === "nonBankAdmin" && (
        <InstitutionDetails
          loading={loading2}
          loading4={loading5}
          loading5={loading6}
          loading6={loading7}
          loading7={loading8}
          loading8={loading9}
          loading9={loading10}
          loading10={loading11}
          callMain4={getInstitutionss4}
          callMain5={getInstitutionss5}
          callMain6={getInstitutionss6}
          callMain7={getInstitutionss7}
          callMain8={getInstitutionss8}
          callMain9={getInstitutionss9}
          callMain10={getInstitutionss10}
          data4={savedData2?.dataDashboard4 || dataDashboard4}
          data5={savedData2?.dataDashboard5 || dataDashboard5}
          data6={savedData2?.dataDashboard6 || dataDashboard6}
          data7={savedData2?.dataDashboard7 || dataDashboard7}
          data8={savedData2?.dataDashboard8 || dataDashboard8}
          data9={savedData2?.dataDashboard9 || dataDashboard9}
          data10={savedData2?.dataDashboard10 || dataDashboard10}
          changedState={changedState}
          setChangedState={setChangedState}
          data={savedData2?.dataDashboard || dataDashboard}
          boundType={savedData2?.oneBoundType || oneBoundType}
          setBoundType={setOneBoundType}
          seconds={seconds}
          setSeconds={setSeconds}
          callMain={getInstitutionss}
          id={userData?.userDetail?.institution?.id}
          callBound={() => {
            getInstitutionss(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=indicator`
            );

            getInstitutionss4(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=approvalRate`
            );

            getInstitutionss5(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss6(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss7(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=recentBanks`
            );

            getInstitutionss8(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );

            getInstitutionss9(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transactionPerformance`
            );
            getInstitutionss10(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transaction`
            );
          }}
        />
      )}
      {userData?.userDetail?.role === "nonBankUser1" && (
        <InstitutionDetails
          loading={loading2}
          loading4={loading5}
          loading5={loading6}
          loading6={loading7}
          loading7={loading8}
          loading8={loading9}
          loading9={loading10}
          loading10={loading11}
          callMain4={getInstitutionss4}
          callMain5={getInstitutionss5}
          callMain6={getInstitutionss6}
          callMain7={getInstitutionss7}
          callMain8={getInstitutionss8}
          callMain9={getInstitutionss9}
          callMain10={getInstitutionss10}
          data4={savedData2?.dataDashboard4 || dataDashboard4}
          data5={savedData2?.dataDashboard5 || dataDashboard5}
          data6={savedData2?.dataDashboard6 || dataDashboard6}
          data7={savedData2?.dataDashboard7 || dataDashboard7}
          data8={savedData2?.dataDashboard8 || dataDashboard8}
          data9={savedData2?.dataDashboard9 || dataDashboard9}
          data10={savedData2?.dataDashboard10 || dataDashboard10}
          changedState={changedState}
          setChangedState={setChangedState}
          data={savedData2?.dataDashboard || dataDashboard}
          boundType={savedData2?.oneBoundType || oneBoundType}
          setBoundType={setOneBoundType}
          seconds={seconds}
          setSeconds={setSeconds}
          callMain={getInstitutionss}
          id={userData?.userDetail?.institution?.id}
          callBound={() => {
            getInstitutionss(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=indicator`
            );

            getInstitutionss4(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=approvalRate`
            );

            getInstitutionss5(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss6(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss7(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=recentBanks`
            );

            getInstitutionss8(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );

            getInstitutionss9(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transactionPerformance`
            );
            getInstitutionss10(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transaction`
            );
          }}
        />
      )}

      {userData?.userDetail?.role === "nonBankUser2" && (
        <InstitutionDetails
          loading={loading2}
          loading4={loading5}
          loading5={loading6}
          loading6={loading7}
          loading7={loading8}
          loading8={loading9}
          loading9={loading10}
          loading10={loading11}
          callMain4={getInstitutionss4}
          callMain5={getInstitutionss5}
          callMain6={getInstitutionss6}
          callMain7={getInstitutionss7}
          callMain8={getInstitutionss8}
          callMain9={getInstitutionss9}
          callMain10={getInstitutionss10}
          data4={savedData2?.dataDashboard4 || dataDashboard4}
          data5={savedData2?.dataDashboard5 || dataDashboard5}
          data6={savedData2?.dataDashboard6 || dataDashboard6}
          data7={savedData2?.dataDashboard7 || dataDashboard7}
          data8={savedData2?.dataDashboard8 || dataDashboard8}
          data9={savedData2?.dataDashboard9 || dataDashboard9}
          data10={savedData2?.dataDashboard10 || dataDashboard10}
          changedState={changedState}
          setChangedState={setChangedState}
          data={savedData2?.dataDashboard || dataDashboard}
          boundType={savedData2?.oneBoundType || oneBoundType}
          setBoundType={setOneBoundType}
          seconds={seconds}
          setSeconds={setSeconds}
          callMain={getInstitutionss}
          id={userData?.userDetail?.institution?.id}
          callBound={() => {
            getInstitutionss(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=indicator`
            );

            getInstitutionss4(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=approvalRate`
            );

            getInstitutionss5(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss6(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );
            getInstitutionss7(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=recentBanks`
            );

            getInstitutionss8(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
            );

            getInstitutionss9(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transactionPerformance`
            );
            getInstitutionss10(
              `/${userData?.userDetail?.institution?.id}?direction=${
                oneBoundType === "inbound" ? "outbound" : "inbound"
              }&indicatorLastPeriod=${seconds}&reportType=transaction`
            );
          }}
        />
      )}
      {userData?.userDetail?.role === "chiefAdmin" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getDashboardAnalysis(
                    `?institutionType=${e.target.value}${
                      dateFrom && dateTo
                        ? `${`&dateFrom=${dateFrom}&dateTo=${dateTo}`}`
                        : ""
                    }&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                  );
                  getDashboardAnalysiss(
                    `?institutionType=${e.target.value}${
                      dateFrom && dateTo
                        ? `${`&dateFrom=${dateFrom}&dateTo=${dateTo}`}`
                        : ""
                    }&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                  );
                  getInstitutionPerformance(
                    `?institutionType=${e.target.value}${
                      dateFrom && dateTo
                        ? `${`&dateFrom=${dateFrom}&dateTo=${dateTo}`}`
                        : ""
                    }&ipDuration=${ipDuration}&reportType=institutionPerformance`
                  );

                  getTransactionPerformance(
                    `?institutionType=${e.target.value}${
                      dateFrom && dateTo
                        ? `${`&dateFrom=${dateFrom}&dateTo=${dateTo}`}`
                        : ""
                    }&reportType=transactionPerformance`
                  );
                  getTransactionReport(
                    `?institutionType=${e.target.value}${
                      dateFrom && dateTo
                        ? `${`&dateFrom=${dateFrom}&dateTo=${dateTo}`}`
                        : ""
                    }&reportType=transactionReport`
                  );

                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=indicator`
                          );
                          getDashboardAnalysis3(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=approvalRate`
                          );
                          getInstitutionPerformance2(
                            `?reportType=institutionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );

                          getTransactionPerformance(
                            `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          getTransactionReport(
                            `?reportType=transactionReport&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          getInstitutionPerformance(
                            `?reportType=institutionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                          );
                          getDashboardAnalysis3(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                          );
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
            </div>
          </Head>
          <Head>
            <div
              className="top"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <p style={{ margin: "10px 0" }}>Response Time</p>
            </div>
          </Head>
          {loading ? (
            <Skeleton2 />
          ) : (
            sitePerformanceIndicator && (
              <GaugeStyle>
                {sitePerformanceIndicator?.map((item) => {
                  return (
                    <div className="gauge">
                      <GaugeChart
                        id="gauge-chart3"
                        nrOfLevels={30}
                        colors={["#37ffa8", "#FFC371", "#EA4228"]}
                        arcWidth={0.3}
                        style={{ width: "100%" }}
                        textColor="#fd9c0a0"
                        hideText={true}
                        percent={
                          item?.averageSec > 45 ? 45 : item?.averageSec / 45
                        }
                      />
                      <div className="gauge_sec">{item?.averageSec}s</div>
                      <div className="gauge_text">{item?.institution}</div>
                    </div>
                  );
                })}
              </GaugeStyle>
            )
          )}
          <div
            style={{ color: "#a7a7a7", marginBottom: "40px", fontSize: "16px" }}
          >
            {loading ? (
              <Skeleton2 height="30px" />
            ) : (
              sitePerformanceIndicator?.length === 0 && "No Response Time Data"
            )}
          </div>

          <Head>
            <div
              className="top"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <p style={{ margin: "10px 0" }}>Approval Rate</p>
            </div>
          </Head>
          {loading ? (
            <Skeleton2 />
          ) : (
            siteApprovalRate && (
              <GaugeStyle>
                {siteApprovalRate?.map((item) => {
                  return (
                    <div className="gauge">
                      <GaugeChart
                        id="gauge-chart3"
                        nrOfLevels={30}
                        colors={["#EA4228", "#FFC371", "#37ffa8"]}
                        arcWidth={0.3}
                        style={{ width: "100%" }}
                        textColor="#fd9c0a0"
                        hideText={true}
                        percent={
                          item?.approvalRate > 100
                            ? 100 / 100
                            : item?.approvalRate / 100
                        }
                      />
                      <div className="gauge_sec">
                        {item?.approvalRate > 100 ? 100 : item?.approvalRate}%
                      </div>
                      <div className="gauge_text">{item?.institution}</div>
                    </div>
                  );
                })}
              </GaugeStyle>
            )
          )}
          <div
            style={{ color: "#a7a7a7", marginBottom: "40px", fontSize: "16px" }}
          >
            {loading ? (
              <Skeleton2 height="30px" />
            ) : (
              siteApprovalRate?.length === 0 && "No Approval Rate Data"
            )}
          </div>

          <Chatgrid>
            <TransactionReport>
              <div className="inner">
                <Transaction>
                  <Statistic>
                    <div>
                      <span>Statistics</span>
                      <p>Transaction Report</p>
                    </div>
                    <div className="outwardTransaction">
                      <VscCircleFilled style={{ color: "#FF993A" }} size={15} />
                      Inbound Transaction
                    </div>
                    <div className="outwardTransaction">
                      <VscCircleFilled style={{ color: "#04A3E5" }} size={15} />
                      Outbound Transaction
                    </div>
                  </Statistic>
                </Transaction>
              </div>
              {loading2 ? (
                <Skeleton2 height="400px" />
              ) : transactionReportInfo?.length ? (
                <LineChartExample chartData={transactionReportInfo} />
              ) : loading2 ? (
                <Skeleton2 height="0px" />
              ) : (
                <div
                  style={{
                    color: "#a7a7a7",
                    marginBottom: "40px",
                    fontSize: "16px",
                    padding: "20px",
                  }}
                >
                  No Transactions Report
                </div>
              )}
            </TransactionReport>
            <TransactionReport>
              <div
                style={{
                  padding: "0px 30px",
                  paddingTop: "30px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  Today's Transactions
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.2554" cy="12" r="12" fill="#BDBDBD" />
                    <rect
                      x="10.2554"
                      y="9.3335"
                      width="4.17391"
                      height="10.6666"
                      rx="2.08695"
                      fill="white"
                    />
                    <rect
                      x="10.2554"
                      y="4"
                      width="4.17391"
                      height="3.99999"
                      rx="2"
                      fill="white"
                    />
                  </svg>
                </div>
                <h2
                  style={{
                    borderBottom: "1px solid #F0F0F0",
                    padding: "0px 0px",
                    paddingBottom: "20px",
                    fontWeight: "500",
                  }}
                >
                  {kFormatter3(totalAmount)}
                </h2>
              </div>

              {loading3 ? (
                <Skeleton2 height="400px" />
              ) : (
                <TodayTransactionsChart
                  options={options3}
                  countAmount={kFormatter2(totalCount)}
                  data={[
                    {
                      pendingAmount: pendingTransactionAmount,
                      pendingCount: pendingTransactionCount,
                    },
                    {
                      successfulAmount: successTransactionAmount,
                      successfulCount: successTransactionCount,
                    },
                    {
                      failedAmount: failedTransactionAmount,
                      failedCount: failedTransactionCount,
                    },
                  ]}
                />
              )}
            </TransactionReport>
          </Chatgrid>
          <Chatgrid2>
            <TransactionReport>
              <FlexPerformance>
                <div>
                  <span>Statistics</span>
                  <p>Institution Performance</p>
                </div>
                <div className="btn">
                  <button
                    onClick={() => {
                      setBoundType("inboundTransaction");
                    }}
                    style={{
                      backgroundColor:
                        boundType === "inboundTransaction" && "#14A2FD",
                      color:
                        boundType !== "inboundTransaction" ? "gray" : "white",
                      border:
                        boundType !== "inboundTransaction" &&
                        "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Inbound Performance
                  </button>
                  <button
                    onClick={() => {
                      setBoundType("outboundTransaction");
                    }}
                    style={{
                      backgroundColor:
                        boundType === "outboundTransaction" && "#14A2FD",
                      border:
                        boundType !== "outboundTransaction" &&
                        "1px solid gainsboro",
                      color:
                        boundType !== "outboundTransaction" ? "gray" : "white",
                      cursor: "pointer",
                    }}
                  >
                    Outbound Performance
                  </button>
                </div>
                <div className="gradient">
                  <span
                    style={{
                      backgroundColor: ipDuration === "daily" && "#04A3E5",
                      padding: "10px",
                      borderRadius: "10px",
                      color: ipDuration === "daily" && "white",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setIpDuration("daily");
                      getInstitutionPerformance(
                        `?institutionType=${institutionType}&ipDuration=${"daily"}&reportType=institutionPerformance`
                      );
                    }}
                  >
                    Daily
                  </span>
                  <span
                    style={{
                      backgroundColor: ipDuration === "weekly" && "#04A3E5",
                      padding: "10px",
                      borderRadius: "10px",
                      color: ipDuration === "weekly" && "white",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setIpDuration("weekly");
                      getInstitutionPerformance(
                        `?institutionType=${institutionType}&ipDuration=${"weekly"}&reportType=institutionPerformance`
                      );
                    }}
                  >
                    Weekly
                  </span>
                </div>
              </FlexPerformance>
              {loading4 ? (
                <Skeleton2 height="400px" />
              ) : (
                <Institution data={options} />
              )}
            </TransactionReport>
          </Chatgrid2>

          <TransactionPerformanc>
            <FlexPerformance>
              <div className="performance">
                <span>Statistics</span>
                <p>Transaction Performance</p>
              </div>

              <div className="btn">
                <button
                  onClick={() => {
                    getTransactionPerformance(
                      `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                        institutionType
                          ? `&institutionType=${institutionType}`
                          : ""
                      }&dateFrom=${moment(new Date()).format(
                        "DD-MM-YYYY "
                      )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                    );
                  }}
                  style={{
                    backgroundColor: "#FFC371",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  Today
                </button>
                <button
                  onClick={() => {
                    setBoundType2("Inbound");
                    getTransactionPerformance(
                      `?reportType=transactionPerformance&direction=inbound&indicatorLastPeriod=${secondsEnter}${
                        institutionType
                          ? `&institutionType=${institutionType}`
                          : ""
                      }&dateFrom=${moment(new Date()).format(
                        "DD-MM-YYYY "
                      )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                    );
                  }}
                  style={{
                    backgroundColor: boundType2 === "Inbound" && "#14A2FD",
                    color: boundType2 !== "Inbound" ? "gray" : "white",
                    border: boundType2 !== "Inbound" && "1px solid gainsboro",
                    cursor: "pointer",
                  }}
                >
                  Inbound Performance
                </button>
                <button
                  onClick={() => {
                    setBoundType2("Outbound");
                    getTransactionPerformance(
                      `?reportType=transactionPerformance&direction=outbound&indicatorLastPeriod=${secondsEnter}${
                        institutionType
                          ? `&institutionType=${institutionType}`
                          : ""
                      }&dateFrom=${moment(new Date()).format(
                        "DD-MM-YYYY "
                      )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                    );
                  }}
                  style={{
                    backgroundColor: boundType2 === "Outbound" && "#14A2FD",
                    color: boundType2 !== "Outbound" ? "gray" : "white",
                    border: boundType2 !== "Outbound" && "1px solid gainsboro",
                    cursor: "pointer",
                  }}
                >
                  Outbound Performance
                </button>

                <div className="outwardTransaction">
                  <VscCircleFilled style={{ color: "#01A926" }} size={15} />
                  Successful Transaction
                </div>
                <div className="outwardTransaction">
                  <VscCircleFilled style={{ color: "#FF993A" }} size={15} />
                  Pending Transaction
                </div>
                <div className="outwardTransaction">
                  <VscCircleFilled style={{ color: "#FF0000" }} size={15} />
                  Failed Transaction
                </div>
              </div>
            </FlexPerformance>
            {loading2 ? (
              <Skeleton2 height="300px" />
            ) : (
              <TransactionPerformance options={options2} />
            )}
          </TransactionPerformanc>
          <br></br>
          <br></br>
          <Table>
            <TableHead>
              <div className="table_head">
                <div>
                  <div className="title_b">Recent Transactions</div>
                </div>
                <div className="table_head_inner"></div>
              </div>
            </TableHead>
            <TableBody>
              <TableBodyContent className="table_body_head grid_attribute">
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Institution
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>Txid</div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Source bank
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Dest bank
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Account No.
                </div>
                <div style={{ width: "120px", marginRight: "10px" }}>
                  Amount
                </div>
                <div
                  style={{
                    width: "250px",
                    marginRight: "10px",
                  }}
                >
                  Remark
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>
                  status message
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  status code
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>
                  beneficiary
                </div>
                <div style={{ width: "110px", marginRight: "10px" }}>
                  sender
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  debit account
                </div>
                <div style={{ width: "60px", marginRight: "10px" }}>
                  approved
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  request type
                </div>
                <div style={{ width: "120px", marginRight: "10px" }}>
                  reference
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  client
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  request id
                </div>
                <div style={{ width: "160px", marginRight: "10px" }}>
                  request time
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>route</div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  route bin
                </div>
                <div style={{ width: "160px", marginRight: "10px" }}>
                  response time
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  response id
                </div>

                <div style={{ width: "180px", marginRight: "10px" }}>rrn</div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  requery count
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  reversible
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  batch id
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  direction
                </div>
              </TableBodyContent>

              <div>
                {" "}
                <TableBodyContent>
                  {recentTransactions?.map((item) => {
                    return (
                      <div className="table_body_item grid_attribute">
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.institution || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.txid || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.sourcebank || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.destbank || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.accountno || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "120px",
                          }}
                        >
                          {kFormatter3(item?.amount)}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.remark || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.statusmessage || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.statuscode || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.beneficiary ? `${item?.beneficiary}` : "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "110px",
                          }}
                        >
                          {item?.sender || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.debitaccount || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "60px",
                          }}
                        >
                          {(item?.approved && "True") || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requesttype || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "120px",
                          }}
                        >
                          {item?.reference || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.client || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requestid || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "160px",
                          }}
                        >
                          {moment(item?.requesttime)
                            .subtract(1, "hours")
                            .format("DD-MM-YYYY hh:mm")}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.route || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.routebin || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "160px",
                          }}
                        >
                          {moment(item?.responsetime)
                            .subtract(1, "hours")
                            .format("DD-MM-YYYY hh:mm")}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.responseid || "N/A"}
                        </div>

                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "180px",
                          }}
                        >
                          {item?.rrn || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requerycount || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.reversible || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.batchid || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.direction || "-"}
                        </div>
                      </div>
                    );
                  })}
                </TableBodyContent>
              </div>
            </TableBody>
            <div
              style={{
                padding: "20px",
                width: "fit-content",
                marginLeft: "auto",
              }}
            >
              <Link
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#14A2FD",
                }}
                to="/transactions"
              >
                View All Transactions{" "}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_127_5725)">
                    <path
                      d="M8.15674 6.19941L11.9734 10.0244L8.15674 13.8494L9.33174 15.0244L14.3317 10.0244L9.33174 5.02441L8.15674 6.19941Z"
                      fill="#14A2FD"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_127_5725">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.998535 20.0244) rotate(-90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </div>
          </Table>
        </>
      )}

      {userData?.userDetail?.role === "subAdmin1" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getDashboardAnalysis(
                    `?institutionType=${e.target.value}&dateFrom=${dateFrom}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                  );
                  getDashboardAnalysiss(
                    `?institutionType=${e.target.value}&dateFrom=${dateFrom}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                  );
                  getInstitutionPerformance(
                    `?institutionType=${e.target.value}&ipDuration=${ipDuration}&reportType=institutionPerformance`
                  );

                  getTransactionPerformance(
                    `?institutionType=${e.target.value}&reportType=transactionPerformance`
                  );
                  getTransactionReport(
                    `?institutionType=${e.target.value}&reportType=transactionReport`
                  );

                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=indicator`
                          );
                          getDashboardAnalysis3(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=approvalRate`
                          );
                          getInstitutionPerformance2(
                            `?reportType=institutionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );

                          getTransactionPerformance(
                            `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          getTransactionReport(
                            `?reportType=transactionReport&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          getInstitutionPerformance(
                            `?reportType=institutionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                          );
                          getDashboardAnalysis3(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                          );
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
              {/*        <p
                onClick={() => {
                  setDateFilter(!dateFilter);
                  setSecondsOpen(false);
                  setDateFrom();
                  setDateTo();
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                FILTER BY DATE
                <BsFillCalendarWeekFill size={20} color={color} />
                {dateFilter && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "290%" }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gridGap: "10px",
                        marginTop: "18px",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <label>Start Date</label>

                        <input
                          style={{
                            marginTop: "6px",
                            width: "86%",
                            padding: "14px",
                            borderRadius: "6px",
                            border: "1px solid #5c5c5c",
                          }}
                          label="Request Time"
                          type="date"
                          onChange={(e) => {
                            setDateFrom(e.target.value);
                            if (dateTo && e.target.value) {
                              getDashboardAnalysis(
                                `?institutionType=${institutionType}&dateFrom=${e.target.value}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                              );
                              getDashboardAnalysiss(
                                `?institutionType=${institutionType}&dateFrom=${e.target.value}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                              );
                            }
                          }}
                        />
                      </div>
                      <div>
                        <label>End State</label>

                        <input
                          style={{
                            marginTop: "6px",
                            width: "86%",
                            padding: "14px",
                            borderRadius: "6px",
                            border: "1px solid #5c5c5c",
                          }}
                          label="Request Time"
                          type="date"
                          onChange={(e) => {
                            setDateTo(e.target.value);
                            if (dateFrom && e.target.value) {
                              getDashboardAnalysis(
                                `?institutionType=${institutionType}&dateFrom=${dateFrom}&dateTo=${e.target.value}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                              );
                              getDashboardAnalysiss(
                                `?institutionType=${institutionType}&dateFrom=${dateFrom}&dateTo=${e.target.value}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                  </DropDown>
                )}
              </p> */}
            </div>
          </Head>

          {handleCheckMetric(
            "sitePerformance",
            userData?.userDetail?.metrics
          ) && (
            <>
              <Head>
                <div
                  className="top"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <p style={{ margin: "10px 0" }}>Response Time</p>
                </div>
              </Head>{" "}
              {loading && <Skeleton2 height="30px" />}
              {loading ? (
                <Skeleton2 />
              ) : (
                sitePerformanceIndicator && (
                  <GaugeStyle>
                    {sitePerformanceIndicator?.map((item) => {
                      return (
                        <div className="gauge">
                          <GaugeChart
                            id="gauge-chart3"
                            nrOfLevels={30}
                            colors={["#37ffa8", "#FFC371", "#EA4228"]}
                            arcWidth={0.3}
                            style={{ width: "100%" }}
                            textColor="#fd9c0a0"
                            hideText={true}
                            percent={
                              item?.averageSec > 45 ? 45 : item?.averageSec / 45
                            }
                          />
                          <div className="gauge_sec">{item?.averageSec}s</div>
                          <div className="gauge_text">{item?.institution}</div>
                        </div>
                      );
                    })}
                  </GaugeStyle>
                )
              )}
              <div
                style={{
                  color: "#a7a7a7",
                  marginBottom: "40px",
                  fontSize: "16px",
                }}
              >
                {loading ? (
                  <Skeleton2 height="30px" />
                ) : (
                  sitePerformanceIndicator?.length === 0 &&
                  "No Response Time Data"
                )}
              </div>
              <Head>
                <div
                  className="top"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <p style={{ margin: "10px 0" }}>Approval Rate</p>
                </div>
              </Head>{" "}
              {loading && <Skeleton2 height="30px" />}
              {loading ? (
                <Skeleton2 />
              ) : (
                siteApprovalRate && (
                  <GaugeStyle>
                    {siteApprovalRate?.map((item) => {
                      return (
                        <div className="gauge">
                          <GaugeChart
                            id="gauge-chart3"
                            nrOfLevels={30}
                            colors={["#EA4228", "#FFC371", "#37ffa8"]}
                            arcWidth={0.3}
                            style={{ width: "100%" }}
                            textColor="#fd9c0a0"
                            hideText={true}
                            percent={item?.approvalRate / 100}
                          />
                          <div className="gauge_sec">{item?.approvalRate}%</div>
                          <div className="gauge_text">{item?.institution}</div>
                        </div>
                      );
                    })}
                  </GaugeStyle>
                )
              )}
              <div
                style={{
                  color: "#a7a7a7",
                  marginBottom: "40px",
                  fontSize: "16px",
                }}
              >
                {loading ? (
                  <Skeleton2 height="30px" />
                ) : (
                  siteApprovalRate?.length === 0 && "No Approval Rate Data"
                )}
              </div>
            </>
          )}
          <Chatgrid>
            {handleCheckMetric(
              "transactionReport",
              userData?.userDetail?.metrics
            ) && (
              <TransactionReport>
                <div className="inner">
                  <Transaction>
                    <Statistic>
                      <div>
                        <span>Statistics</span>
                        <p>Transaction Report</p>
                      </div>

                      <div className="outwardTransaction">
                        <VscCircleFilled
                          style={{ color: "#FF993A" }}
                          size={15}
                        />
                        Inbound Transaction
                      </div>
                      <div className="outwardTransaction">
                        <VscCircleFilled
                          style={{ color: "#04A3E5" }}
                          size={15}
                        />
                        Outbound Transaction
                      </div>
                    </Statistic>
                  </Transaction>
                </div>
                {loading2 ? (
                  <Skeleton2 height="400px" />
                ) : transactionReportInfo?.length ? (
                  <LineChartExample chartData={transactionReportInfo} />
                ) : loading2 ? (
                  <Skeleton2 height="0px" />
                ) : (
                  <div
                    style={{
                      color: "#a7a7a7",
                      marginBottom: "40px",
                      fontSize: "16px",
                      padding: "20px",
                    }}
                  >
                    No Transactions Report
                  </div>
                )}
              </TransactionReport>
            )}
            {handleCheckMetric(
              "todayTransaction",
              userData?.userDetail?.metrics
            ) && (
              <TransactionReport>
                <div
                  style={{
                    padding: "0px 30px",
                    paddingTop: "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    Today's Transactions
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.2554" cy="12" r="12" fill="#BDBDBD" />
                      <rect
                        x="10.2554"
                        y="9.3335"
                        width="4.17391"
                        height="10.6666"
                        rx="2.08695"
                        fill="white"
                      />
                      <rect
                        x="10.2554"
                        y="4"
                        width="4.17391"
                        height="3.99999"
                        rx="2"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <h2
                    style={{
                      borderBottom: "1px solid #F0F0F0",
                      padding: "0px 0px",
                      paddingBottom: "20px",
                      fontWeight: "500",
                    }}
                  >
                    {kFormatter3(totalAmount)}
                  </h2>
                </div>

                {loading3 ? (
                  <Skeleton2 height="400px" />
                ) : (
                  <TodayTransactionsChart
                    options={options3}
                    countAmount={kFormatter2(totalCount)}
                    data={[
                      {
                        pendingAmount: pendingTransactionAmount,
                        pendingCount: pendingTransactionCount,
                      },
                      {
                        successfulAmount: successTransactionAmount,
                        successfulCount: successTransactionCount,
                      },
                      {
                        failedAmount: failedTransactionAmount,
                        failedCount: failedTransactionCount,
                      },
                    ]}
                  />
                )}
              </TransactionReport>
            )}
          </Chatgrid>
          <Chatgrid2>
            {handleCheckMetric(
              "institutionPerformance",
              userData?.userDetail?.metrics
            ) && (
              <TransactionReport>
                <FlexPerformance>
                  <div>
                    <span>Statistics</span>
                    <p>Institution Performance</p>
                  </div>
                  <div className="btn">
                    <button
                      onClick={() => {
                        setBoundType("inboundTransaction");
                      }}
                      style={{
                        backgroundColor:
                          boundType === "inboundTransaction" && "#14A2FD",
                        color:
                          boundType !== "inboundTransaction" ? "gray" : "white",
                        border:
                          boundType !== "inboundTransaction" &&
                          "1px solid gainsboro",
                        cursor: "pointer",
                      }}
                    >
                      Inbound Performance
                    </button>
                    <button
                      onClick={() => {
                        setBoundType("outboundTransaction");
                      }}
                      style={{
                        backgroundColor:
                          boundType === "outboundTransaction" && "#14A2FD",
                        border:
                          boundType !== "outboundTransaction" &&
                          "1px solid gainsboro",
                        color:
                          boundType !== "outboundTransaction"
                            ? "gray"
                            : "white",
                        cursor: "pointer",
                      }}
                    >
                      Outbound Performance
                    </button>
                  </div>
                  <div className="gradient">
                    <span
                      style={{
                        backgroundColor: ipDuration === "daily" && "#04A3E5",
                        padding: "10px",
                        borderRadius: "10px",
                        color: ipDuration === "daily" && "white",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIpDuration("daily");
                        getInstitutionPerformance(
                          `?institutionType=${institutionType}&ipDuration=${"daily"}&reportType=institutionPerformance`
                        );
                      }}
                    >
                      Daily
                    </span>
                    <span
                      style={{
                        backgroundColor: ipDuration === "weekly" && "#04A3E5",
                        padding: "10px",
                        borderRadius: "10px",
                        color: ipDuration === "weekly" && "white",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIpDuration("weekly");
                        getInstitutionPerformance(
                          `?institutionType=${institutionType}&ipDuration=${"weekly"}&reportType=institutionPerformance`
                        );
                      }}
                    >
                      Weekly
                    </span>
                  </div>
                </FlexPerformance>
                {loading4 ? (
                  <Skeleton2 height="400px" />
                ) : (
                  <Institution data={options} />
                )}
              </TransactionReport>
            )}
          </Chatgrid2>

          {handleCheckMetric(
            "transactionPerformance",
            userData?.userDetail?.metrics
          ) && (
            <TransactionPerformanc>
              <FlexPerformance>
                <div className="performance">
                  <span>Statistics</span>
                  <p>Transaction Performance</p>
                </div>

                <div className="btn">
                  <button
                    onClick={() => {
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: "#FFC371",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Today
                  </button>
                  <button
                    onClick={() => {
                      setBoundType2("Inbound");
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&direction=inbound&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: boundType2 === "Inbound" && "#14A2FD",
                      color: boundType2 !== "Inbound" ? "gray" : "white",
                      border: boundType2 !== "Inbound" && "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Inbound Performance
                  </button>
                  <button
                    onClick={() => {
                      setBoundType2("Outbound");
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&direction=outbound&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: boundType2 === "Outbound" && "#14A2FD",
                      color: boundType2 !== "Outbound" ? "gray" : "white",
                      border:
                        boundType2 !== "Outbound" && "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Outbound Performance
                  </button>

                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#01A926" }} size={15} />
                    Successful Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF993A" }} size={15} />
                    Pending Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF0000" }} size={15} />
                    Failed Transaction
                  </div>
                </div>
              </FlexPerformance>
              {loading2 ? (
                <Skeleton2 height="300px" />
              ) : (
                <TransactionPerformance options={options2} />
              )}{" "}
            </TransactionPerformanc>
          )}
          <br></br>
          <br></br>
          <Table>
            <TableHead>
              <div className="table_head">
                <div>
                  <div className="title_b">Recent Transactions</div>
                </div>
                <div className="table_head_inner"></div>
              </div>
            </TableHead>
            <TableBody>
              <TableBodyContent className="table_body_head grid_attribute">
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Institution
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>Txid</div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Source bank
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Dest bank
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Account No.
                </div>
                <div style={{ width: "120px", marginRight: "10px" }}>
                  Amount
                </div>
                <div
                  style={{
                    width: "250px",
                    marginRight: "10px",
                  }}
                >
                  Remark
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>
                  status message
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  status code
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>
                  beneficiary
                </div>
                <div style={{ width: "110px", marginRight: "10px" }}>
                  sender
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  debit account
                </div>
                <div style={{ width: "60px", marginRight: "10px" }}>
                  approved
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  request type
                </div>
                <div style={{ width: "120px", marginRight: "10px" }}>
                  reference
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  client
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  request id
                </div>
                <div style={{ width: "160px", marginRight: "10px" }}>
                  request time
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>route</div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  route bin
                </div>
                <div style={{ width: "160px", marginRight: "10px" }}>
                  response time
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  response id
                </div>

                <div style={{ width: "180px", marginRight: "10px" }}>rrn</div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  requery count
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  reversible
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  batch id
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  direction
                </div>
              </TableBodyContent>

              <div>
                {" "}
                <TableBodyContent>
                  {recentTransactions?.map((item) => {
                    return (
                      <div className="table_body_item grid_attribute">
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.institution || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.txid || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.sourcebank || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.destbank || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.accountno || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "120px",
                          }}
                        >
                          {kFormatter3(item?.amount)}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.remark || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.statusmessage || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.statuscode || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.beneficiary ? `${item?.beneficiary}` : "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "110px",
                          }}
                        >
                          {item?.sender || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.debitaccount || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "60px",
                          }}
                        >
                          {(item?.approved && "True") || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requesttype || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "120px",
                          }}
                        >
                          {item?.reference || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.client || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requestid || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "160px",
                          }}
                        >
                          {moment(item?.requesttime)
                            .subtract(1, "hours")
                            .format("DD-MM-YYYY hh:mm")}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.route || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.routebin || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "160px",
                          }}
                        >
                          {moment(item?.responsetime)
                            .subtract(1, "hours")
                            .format("DD-MM-YYYY hh:mm")}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.responseid || "N/A"}
                        </div>

                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "180px",
                          }}
                        >
                          {item?.rrn || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requerycount || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.reversible || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.batchid || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.direction || "-"}
                        </div>
                      </div>
                    );
                  })}
                </TableBodyContent>
              </div>
            </TableBody>
            <div
              style={{
                padding: "20px",
                width: "fit-content",
                marginLeft: "auto",
              }}
            >
              <Link
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#14A2FD",
                }}
                to="/transactions"
              >
                View All Transactions{" "}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_127_5725)">
                    <path
                      d="M8.15674 6.19941L11.9734 10.0244L8.15674 13.8494L9.33174 15.0244L14.3317 10.0244L9.33174 5.02441L8.15674 6.19941Z"
                      fill="#14A2FD"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_127_5725">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.998535 20.0244) rotate(-90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </div>
          </Table>
        </>
      )}
      {userData?.userDetail?.role === "subAdmin2" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getDashboardAnalysis(
                    `?institutionType=${e.target.value}&dateFrom=${dateFrom}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                  );
                  getDashboardAnalysiss(
                    `?institutionType=${e.target.value}&dateFrom=${dateFrom}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                  );
                  getInstitutionPerformance(
                    `?institutionType=${e.target.value}&ipDuration=${ipDuration}&reportType=institutionPerformance`
                  );

                  getTransactionPerformance(
                    `?institutionType=${e.target.value}&reportType=transactionPerformance`
                  );
                  getTransactionReport(
                    `?institutionType=${e.target.value}&reportType=transactionReport`
                  );
                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <p>Site Performance Indicator</p>
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=indicator`
                          );
                          getDashboardAnalysis3(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=approvalRate`
                          );
                          getInstitutionPerformance2(
                            `?reportType=institutionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );

                          getTransactionPerformance(
                            `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          getTransactionReport(
                            `?reportType=transactionReport&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          getInstitutionPerformance(
                            `?reportType=institutionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                          );
                          getDashboardAnalysis3(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                          );
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {/* hekk */}
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
              {/*              <p
                onClick={() => {
                  setDateFilter(!dateFilter);
                  setSecondsOpen(false);
                  setDateFrom();
                  setDateTo();
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                FILTER BY DATE
                <BsFillCalendarWeekFill size={20} color={color} />
                {dateFilter && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "290%" }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gridGap: "10px",
                        marginTop: "18px",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <label>Start Date</label>

                        <input
                          style={{
                            marginTop: "6px",
                            width: "86%",
                            padding: "14px",
                            borderRadius: "6px",
                            border: "1px solid #5c5c5c",
                          }}
                          label="Request Time"
                          type="date"
                          onChange={(e) => {
                            setDateFrom(e.target.value);
                            if (dateTo && e.target.value) {
                              getDashboardAnalysis(
                                `?institutionType=${institutionType}&dateFrom=${e.target.value}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                              );
                              getDashboardAnalysiss(
                                `?institutionType=${institutionType}&dateFrom=${e.target.value}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                              );
                            }
                          }}
                        />
                      </div>
                      <div>
                        <label>End State</label>

                        <input
                          style={{
                            marginTop: "6px",
                            width: "86%",
                            padding: "14px",
                            borderRadius: "6px",
                            border: "1px solid #5c5c5c",
                          }}
                          label="Request Time"
                          type="date"
                          onChange={(e) => {
                            setDateTo(e.target.value);
                            if (dateFrom && e.target.value) {
                              getDashboardAnalysis(
                                `?institutionType=${institutionType}&dateFrom=${dateFrom}&dateTo=${e.target.value}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                              );
                              getDashboardAnalysiss(
                                `?institutionType=${institutionType}&dateFrom=${dateFrom}&dateTo=${e.target.value}&indicatorLastPeriod=${secondsEnter}&reportType=approvalRate`
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                  </DropDown>
                )}
              </p> */}
            </div>
          </Head>
          {handleCheckMetric(
            "sitePerformance",
            userData?.userDetail?.metrics
          ) && (
            <>
              <Head>
                <div
                  className="top"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <p style={{ margin: "10px 0" }}>Response Time</p>
                </div>
              </Head>{" "}
              {loading && <Skeleton2 height="30px" />}
              {loading ? (
                <Skeleton2 />
              ) : (
                sitePerformanceIndicator && (
                  <GaugeStyle>
                    {sitePerformanceIndicator?.map((item) => {
                      return (
                        <div className="gauge">
                          <GaugeChart
                            id="gauge-chart3"
                            nrOfLevels={30}
                            colors={["#37ffa8", "#FFC371", "#EA4228"]}
                            arcWidth={0.3}
                            style={{ width: "100%" }}
                            textColor="#fd9c0a0"
                            hideText={true}
                            percent={
                              item?.averageSec > 45 ? 45 : item?.averageSec / 45
                            }
                          />
                          <div className="gauge_sec">{item?.averageSec}s</div>
                          <div className="gauge_text">{item?.institution}</div>
                        </div>
                      );
                    })}
                  </GaugeStyle>
                )
              )}
              <div
                style={{
                  color: "#a7a7a7",
                  marginBottom: "40px",
                  fontSize: "16px",
                }}
              >
                {loading ? (
                  <Skeleton2 height="30px" />
                ) : (
                  sitePerformanceIndicator?.length === 0 &&
                  "No Response Time Data"
                )}
              </div>
              <Head>
                <div
                  className="top"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <p style={{ margin: "10px 0" }}>Approval Rate</p>
                </div>
              </Head>{" "}
              {loading && <Skeleton2 height="30px" />}
              {loading ? (
                <Skeleton2 />
              ) : (
                siteApprovalRate && (
                  <GaugeStyle>
                    {siteApprovalRate?.map((item) => {
                      return (
                        <div className="gauge">
                          <GaugeChart
                            id="gauge-chart3"
                            nrOfLevels={30}
                            colors={["#EA4228", "#FFC371", "#37ffa8"]}
                            arcWidth={0.3}
                            style={{ width: "100%" }}
                            textColor="#fd9c0a0"
                            hideText={true}
                            percent={item?.approvalRate / 100}
                          />
                          <div className="gauge_sec">{item?.approvalRate}%</div>
                          <div className="gauge_text">{item?.institution}</div>
                        </div>
                      );
                    })}
                  </GaugeStyle>
                )
              )}
              <div
                style={{
                  color: "#a7a7a7",
                  marginBottom: "40px",
                  fontSize: "16px",
                }}
              >
                {loading ? (
                  <Skeleton2 height="30px" />
                ) : (
                  siteApprovalRate?.length === 0 && "No Approval Rate Data"
                )}
              </div>
            </>
          )}
          <Chatgrid>
            {handleCheckMetric(
              "transactionReport",
              userData?.userDetail?.metrics
            ) && (
              <TransactionReport>
                <div className="inner">
                  <Transaction>
                    <Statistic>
                      <div>
                        <span>Statistics</span>
                        <p>Transaction Report</p>
                      </div>
                      <div className="outwardTransaction">
                        <VscCircleFilled
                          style={{ color: "#FF993A" }}
                          size={15}
                        />
                        Inbound Transaction
                      </div>
                      <div className="outwardTransaction">
                        <VscCircleFilled
                          style={{ color: "#04A3E5" }}
                          size={15}
                        />
                        Outbound Transaction
                      </div>
                    </Statistic>
                  </Transaction>
                </div>
                {loading2 ? (
                  <Skeleton2 height="400px" />
                ) : transactionReportInfo?.length ? (
                  <LineChartExample chartData={transactionReportInfo} />
                ) : loading2 ? (
                  <Skeleton2 height="0px" />
                ) : (
                  <div
                    style={{
                      color: "#a7a7a7",
                      marginBottom: "40px",
                      fontSize: "16px",
                      padding: "20px",
                    }}
                  >
                    No Transactions Report
                  </div>
                )}
              </TransactionReport>
            )}
            {handleCheckMetric(
              "todayTransaction",
              userData?.userDetail?.metrics
            ) && (
              <TransactionReport>
                <div
                  style={{
                    padding: "0px 30px",
                    paddingTop: "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    Today's Transactions
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.2554" cy="12" r="12" fill="#BDBDBD" />
                      <rect
                        x="10.2554"
                        y="9.3335"
                        width="4.17391"
                        height="10.6666"
                        rx="2.08695"
                        fill="white"
                      />
                      <rect
                        x="10.2554"
                        y="4"
                        width="4.17391"
                        height="3.99999"
                        rx="2"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <h2
                    style={{
                      borderBottom: "1px solid #F0F0F0",
                      padding: "0px 0px",
                      paddingBottom: "20px",
                      fontWeight: "500",
                    }}
                  >
                    {kFormatter3(totalAmount)}
                  </h2>
                </div>
                {loading3 ? (
                  <Skeleton2 height="400px" />
                ) : (
                  <TodayTransactionsChart
                    options={options3}
                    countAmount={kFormatter2(totalCount)}
                    data={[
                      {
                        pendingAmount: pendingTransactionAmount,
                        pendingCount: pendingTransactionCount,
                      },
                      {
                        successfulAmount: successTransactionAmount,
                        successfulCount: successTransactionCount,
                      },
                      {
                        failedAmount: failedTransactionAmount,
                        failedCount: failedTransactionCount,
                      },
                    ]}
                  />
                )}
              </TransactionReport>
            )}
          </Chatgrid>
          <Chatgrid2>
            {handleCheckMetric(
              "institutionPerformance",
              userData?.userDetail?.metrics
            ) && (
              <TransactionReport>
                <FlexPerformance>
                  <div>
                    <span>Statistics</span>
                    <p>Institution Performance</p>
                  </div>
                  <div className="btn">
                    <button
                      onClick={() => {
                        setBoundType("inboundTransaction");
                      }}
                      style={{
                        backgroundColor:
                          boundType === "inboundTransaction" && "#14A2FD",
                        color:
                          boundType !== "inboundTransaction" ? "gray" : "white",
                        border:
                          boundType !== "inboundTransaction" &&
                          "1px solid gainsboro",
                        cursor: "pointer",
                      }}
                    >
                      Inbound Performance
                    </button>
                    <button
                      onClick={() => {
                        setBoundType("outboundTransaction");
                      }}
                      style={{
                        backgroundColor:
                          boundType === "outboundTransaction" && "#14A2FD",
                        border:
                          boundType !== "outboundTransaction" &&
                          "1px solid gainsboro",
                        color:
                          boundType !== "outboundTransaction"
                            ? "gray"
                            : "white",
                        cursor: "pointer",
                      }}
                    >
                      Outbound Performance
                    </button>
                  </div>
                  <div className="gradient">
                    <span
                      style={{
                        backgroundColor: ipDuration === "daily" && "#04A3E5",
                        padding: "10px",
                        borderRadius: "10px",
                        color: ipDuration === "daily" && "white",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIpDuration("daily");
                        getInstitutionPerformance(
                          `?institutionType=${institutionType}&ipDuration=${"daily"}&reportType=institutionPerformance`
                        );
                      }}
                    >
                      Daily
                    </span>
                    <span
                      style={{
                        backgroundColor: ipDuration === "weekly" && "#04A3E5",
                        padding: "10px",
                        borderRadius: "10px",
                        color: ipDuration === "weekly" && "white",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIpDuration("weekly");
                        getInstitutionPerformance(
                          `?institutionType=${institutionType}&ipDuration=${"weekly"}&reportType=institutionPerformance`
                        );
                      }}
                    >
                      Weekly
                    </span>
                  </div>
                </FlexPerformance>
                {loading4 ? (
                  <Skeleton2 height="400px" />
                ) : (
                  <Institution data={options} />
                )}
              </TransactionReport>
            )}
          </Chatgrid2>

          {handleCheckMetric(
            "transactionPerformance",
            userData?.userDetail?.metrics
          ) && (
            <TransactionPerformanc>
              <FlexPerformance>
                <div className="performance">
                  <span>Statistics</span>
                  <p>Transaction Performance</p>
                </div>

                <div className="btn">
                  <button
                    onClick={() => {
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: "#FFC371",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Today
                  </button>
                  <button
                    onClick={() => {
                      setBoundType2("Inbound");
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&direction=inbound&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: boundType2 === "Inbound" && "#14A2FD",
                      color: boundType2 !== "Inbound" ? "gray" : "white",
                      border: boundType2 !== "Inbound" && "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Inbound Performance
                  </button>
                  <button
                    onClick={() => {
                      setBoundType2("Outbound");
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&direction=outbound&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: boundType2 === "Outbound" && "#14A2FD",
                      color: boundType2 !== "Outbound" ? "gray" : "white",
                      border:
                        boundType2 !== "Outbound" && "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Outbound Performance
                  </button>

                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#01A926" }} size={15} />
                    Successful Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF993A" }} size={15} />
                    Pending Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF0000" }} size={15} />
                    Failed Transaction
                  </div>
                </div>
              </FlexPerformance>
              {loading2 ? (
                <Skeleton2 height="300px" />
              ) : (
                <TransactionPerformance options={options2} />
              )}
            </TransactionPerformanc>
          )}
          <br></br>
          <br></br>
          <Table>
            <TableHead>
              <div className="table_head">
                <div>
                  <div className="title_b">Recent Transactions</div>
                </div>
                <div className="table_head_inner"></div>
              </div>
            </TableHead>
            <TableBody>
              <TableBodyContent className="table_body_head grid_attribute">
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Institution
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>Txid</div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Source bank
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Dest bank
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  Account No.
                </div>
                <div style={{ width: "120px", marginRight: "10px" }}>
                  Amount
                </div>
                <div
                  style={{
                    width: "250px",
                    marginRight: "10px",
                  }}
                >
                  Remark
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>
                  status message
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  status code
                </div>
                <div style={{ width: "250px", marginRight: "10px" }}>
                  beneficiary
                </div>
                <div style={{ width: "110px", marginRight: "10px" }}>
                  sender
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  debit account
                </div>
                <div style={{ width: "60px", marginRight: "10px" }}>
                  approved
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  request type
                </div>
                <div style={{ width: "120px", marginRight: "10px" }}>
                  reference
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  client
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  request id
                </div>
                <div style={{ width: "160px", marginRight: "10px" }}>
                  request time
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>route</div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  route bin
                </div>
                <div style={{ width: "160px", marginRight: "10px" }}>
                  response time
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  response id
                </div>

                <div style={{ width: "180px", marginRight: "10px" }}>rrn</div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  requery count
                </div>
                <div style={{ width: "80px", marginRight: "10px" }}>
                  reversible
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  batch id
                </div>
                <div style={{ width: "100px", marginRight: "10px" }}>
                  direction
                </div>
              </TableBodyContent>

              <div>
                {" "}
                <TableBodyContent>
                  {recentTransactions?.map((item) => {
                    return (
                      <div className="table_body_item grid_attribute">
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.institution || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.txid || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.sourcebank || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.destbank || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.accountno || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "120px",
                          }}
                        >
                          {kFormatter3(item?.amount)}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.remark || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.statusmessage || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.statuscode || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.beneficiary ? `${item?.beneficiary}` : "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "110px",
                          }}
                        >
                          {item?.sender || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.debitaccount || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "60px",
                          }}
                        >
                          {(item?.approved && "True") || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requesttype || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "120px",
                          }}
                        >
                          {item?.reference || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.client || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requestid || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "160px",
                          }}
                        >
                          {moment(item?.requesttime)
                            .subtract(1, "hours")
                            .format("DD-MM-YYYY hh:mm")}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.route || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.routebin || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "160px",
                          }}
                        >
                          {moment(item?.responsetime)
                            .subtract(1, "hours")
                            .format("DD-MM-YYYY hh:mm")}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.responseid || "N/A"}
                        </div>

                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "180px",
                          }}
                        >
                          {item?.rrn || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requerycount || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.reversible || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.batchid || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.direction || "-"}
                        </div>
                      </div>
                    );
                  })}
                </TableBodyContent>
              </div>
            </TableBody>
            <div
              style={{
                padding: "20px",
                width: "fit-content",
                marginLeft: "auto",
              }}
            >
              <Link
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#14A2FD",
                }}
                to="/transactions"
              >
                View All Transactions{" "}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_127_5725)">
                    <path
                      d="M8.15674 6.19941L11.9734 10.0244L8.15674 13.8494L9.33174 15.0244L14.3317 10.0244L9.33174 5.02441L8.15674 6.19941Z"
                      fill="#14A2FD"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_127_5725">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.998535 20.0244) rotate(-90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </div>
          </Table>
        </>
      )}
      {/* hhh */}
    </DashboardLayout>
  );
}

const SelectInput = styled.div`
  position: relative;
  width: 300px;
  margin-left: auto;

  select {
    width: 100%;
    height: 100%;
    appearance: none;
    border-radius: 20px;
    outline: none;
    padding: 10px;
    font-size: 16px;
    background-color: white;
    margin-bottom: 20px;
    border: 1px solid #e6e7ec;
    color: #019edf;
  }
  .icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-90%);
    pointer-events: none;
  }
`;
const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 30px;
  .top p {
    font-size: 30px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .top span {
    font-size: 15px;
    color: #00a2e5;
    font-weight: 500;
  }
  .timerate {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .timerate span {
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .timerate p {
    font-size: 12.5px;
    display: flex;
    align-items: center;
    gap: 15px;
  }
`;
/* const InstitutionPerformance = styled.div`
  border-radius: 20px;
  background-color: white;
  overflow: hidden;
  overflow: scroll;
  height: auto;
  margin-top: 20px;
  padding: 12px;

  &::-webkit-scrollbar {
    width: 0;
  }
`; */
const TransactionPerformanc = styled.div`
  padding: 12px;
  border-radius: 20px;
  background-color: white;
  margin-top: 20px;
`;

const FlexPerformance = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid gainsboro;
  .outwardTransaction {
    padding: 7px 10px 7px 10px;
    border-radius: 5px;
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px solid #e5e5ef;
  }

  span {
    color: gray;
  }
  .btn {
    display: flex;
    gap: 20px;
  }
  .btn button {
    padding: 5px;
    border: none;
    background-color: transparent;
    border-radius: 5px;
  }
  .gradient {
    background-color: #eff7fa;
    display: flex;
    align-items: center;
    gap: 20px;
    padding-left: 5px;
    border-radius: 5px;
  }
  .gradient select {
    background-color: #eff7fa;
    color: #333333;
    outline: none;
    padding: 5px;
    border: none;
    border-radius: 5px;
  }
  .gradient span {
    font-size: 12px;
  }
`;
const Chatgrid = styled.div`
  display: grid;
  grid-template-columns: 3fr 1.2fr;
  width: 100%;
  gap: 20px;
  margin-bottom: 20px;
`;
const Chatgrid2 = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;
/* const TransactionAnalysis = styled.div`
  background-color: white;
  overflow: hidden;
  overflow: scroll;
  width: 100%;
  border-radius: 20px;
  .inner {
    padding: 20px;
  }
  .bank span {
    font-size: 10px;
  }
  .bank {
    display: flex;
    gap: 8px;
  }

  .star {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .star h3 {
    font-size: 12px;
  }
`; */
const TransactionReport = styled.div`
  border-radius: 20px;
  background-color: white;

  .inner {
    padding: 22px;
  }
`;
const Transaction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  select {
    background-color: #eff7fa;
    color: #333333;
    padding: 10px;
    border: none;
    border-radius: 5px;
    outline: none;
  }
`;
const Statistic = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;

  span {
    color: #9291a5;
    font-size: 12px;
  }
  p {
    font-size: 14px;
  }

  .outwardTransaction {
    padding: 7px 10px 7px 10px;
    border-radius: 5px;
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px solid #e5e5ef;
  }
`;
const GaugeStyle = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
  overflow: hidden;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    width: 0px;
  }

  .gauge {
    text-align: center;
    position: relative;
    width: 260px;

    .gauge_text {
      color: #000000;
      font-size: 15px;
      font-weight: 500;
    }
    .gauge_sec {
      color: #000;
      position: absolute;
      top: 60%;
      left: 50%;
      transform: translate(-50%, -90%);
      z-index: 100;
      font-size: 16px;
      padding: 2px;
      background-color: #f5fcff;
    }
  }
`;
const Table = styled.div`
  background-color: white;
  border-radius: 10px;
`;

const TableHead = styled.div`
  padding: 0 30px;

  .table_tab {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  .table_head {
    padding: 30px 0;
    width: 100%;

    .table_head_inner {
      width: 100%;
      display: flex;
      align-items: center;
      margin-left: 20px;
      justify-content: space-between;
    }
  }

  .title_a {
    font-size: 18px;
    color: #9291a5;
  }

  .title_b {
    font-size: 26px;
    font-weight: 600;
    margin-top: 10px;
  }
`;

const TableBody = styled.div`
  overflow: hidden;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    width: 10px;
    height: 6px;
    padding: 10px;
  }
  &::-webkit-scrollbar-thumb {
    width: 10px;
    background-color: #019edf;
    border-radius: 30px;
  }
  .table_body_head {
    padding: 20px 30px;
    text-transform: uppercase;
    background: #fafafa;
    color: #14a2fd;
  }
  .grid_attribute {
    display: grid;
    grid-template-columns: repeat(28, 1fr);
    width: fit-content;
  }
`;

const TableBodyContent = styled.div`
  padding: 10px 0px;
  text-transform: uppercase;
  font-size: 12px;

  .grid_attribute {
    display: grid;
    grid-template-columns: repeat(28, 1fr);
    width: fit-content;
  }

  .table_body_item {
    padding: 20px 30px;
  }

  .table_body_item:nth-child(even) {
    background: #fafafa;
  }
`;
const DropDown = styled.div`
  position: absolute;
  border: 1px solid #bbbbbb;
  border-radius: 20px;
  top: 180%;
  right: 0;
  background-color: white;
  z-index: 100;
  padding: 0 20px;
  padding-top: 8px;
  width: 220%;
  text-transform: capitalize;
  font-size: 14px;

  .title {
    border-bottom: 1px solid #e9e9e9;
    width: 100%;
    font-size: 14px;
    margin-bottom: 20px;
  }
`;
